import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { courseId as selectedCourseId, courseStructure } from '../../../pages/courses/store/course.selector';
import { CommonModule } from '@angular/common';
import { HelperServiceService } from '../../../utils/helper-service.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-structure-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './structure-section.component.html',
  styleUrl: './structure-section.component.scss'
})
export class StructureSectionComponent {

  courseId: any = '';
  courseStructure$!: Observable<any>;
  courseStructureData: any = []
  tempNodeTitle: string = '';



  constructor(private store: Store,private helperService:HelperServiceService, private router: Router, private route: ActivatedRoute) {
    this.courseStructure$ = this.store.select(courseStructure);
  }

  ngOnInit():void {
    this.getDataFromStore();
  }



  getDataFromStore() {
    this.courseStructure$.pipe(take(1)).subscribe((structure) => {
      if (structure && structure.length > 0) {
        this.courseStructureData = structure.map((node: any) => {
          const existingNode = this.courseStructureData?.find((n: any) => n.id === node.id);
          return {
            ...node,
            isOpen: existingNode?.isOpen ?? false,
            child: (node.child || []).map((child: any) => {
              const existingChild = existingNode?.child?.find((c: any) => c.id === child.id);

              return {
                ...child,
                isOpen: existingChild?.isOpen ?? false,
                grandChild: (child.grandChild || []).map((grandChild: any) => {
                  const existingGrandChild = existingChild?.grandChild?.find((gc: any) => gc.id === grandChild.id);

                  return {
                    ...grandChild,
                    isOpen: existingGrandChild?.isOpen ?? false
                  };
                })
              };
            })
          };
        });
      } else {
        this.courseStructureData = []
      }
    });
  }

  toggleNode(nodeType: number, lvl: number, parentIndex: number, childIndex?: number | null, grandChildIndex?: number | null, contentIndex?: number | null, toggleType: 'edit' | 'visible' = 'edit', inputId?: string, status?: boolean) {
    // this.store.dispatch(CourseActions.toggleEditModeNode({ nodeType, lvl, parentIndex, childIndex, grandChildIndex, contentIndex,toggleType }));
    this.courseStructureData = this.helperService.toggleIsEditingAtLevel(
      this.courseStructureData,
      lvl,
      {
        parentIndex,
        childIndex: childIndex ?? undefined,
        grandChildIndex: grandChildIndex ?? undefined
      },
      nodeType,
      contentIndex ?? undefined,
      toggleType
    );
    console.log(status, toggleType, inputId);

    if (toggleType === 'edit' && inputId) {
      if (status) {
        this.tempNodeTitle = (document.getElementById(inputId ?? '') as HTMLInputElement)?.value || '';
      } else {
        (document.getElementById(inputId ?? '') as HTMLInputElement).classList.remove('error');
        (document.getElementById(inputId ?? '') as HTMLInputElement).value = this.tempNodeTitle;
        this.tempNodeTitle = '';
      }
    }

  }

  playVideo(video: any) {
    if (!video) {
      return;
    }

    this.store.select(selectedCourseId).pipe(take(1)).subscribe((id) => {
      const courseId = id ?? this.route.snapshot.paramMap.get('id');

      if (!courseId) {
        return;
      }

      const queryParams = {
        ...(video?.id ? { videoId: video.id } : {}),
        ...(video?.video_link ? { videoLink: video.video_link } : {}),
        ...(video?.video_title ? { title: video.video_title } : {}),
        ...(video?.thumbnail ? { thumbnail: video.thumbnail } : {})
      };

      this.router.navigate(['/view/course', courseId], { queryParams });
    });
  }

  // drag and drop functions

}
